import { WIDGET_CONFIG } from '../utils/widget-config.util';

export const RESULTS_PER_PAGE = WIDGET_CONFIG.resultsPerPage;
export const DEFAULT_VISIBLE_FACET_VALUES = 5;
export const FACET_INCREMENT = 5;

export const SOLR_FIELD_LIST = 'id,nume,descriere,categorie_id,categorie_nume,domeniu_id,domeniu_nume,tip_id,tip_nume,tip,tipdisponibilitate_id,tipdisponibilitate_nume,judet_id,judet_nume,localitate_id,localitate_nume,institutie_id,institutie_nume,anexe_categ,publictinta_categ,tiparie_categ,proceduri_count,proceduri_online_count';

export const SOLR_JSON_FACET_CONFIG = {
  domeniu_id: {
    type: 'terms',
    field: 'domeniu_id',
    limit: 100,
    mincount: 1
  },
  categorie_id: {
    type: 'terms',
    field: 'categorie_id',
    limit: 100,
    mincount: 1
  },
  tip_id: {
    type: 'terms',
    field: 'tip_id',
    limit: 100,
    mincount: 1
  },
  tipdisponibilitate_id: {
    type: 'terms',
    field: 'tipdisponibilitate_id',
    limit: 100,
    mincount: 1
  },
  judet_id: {
    type: 'terms',
    field: 'judet_id',
    limit: 100,
    mincount: 1
  },
  localitate_id: {
    type: 'terms',
    field: 'localitate_id',
    limit: 100,
    mincount: 1
  },
  anexe_categ: {
    type: 'terms',
    field: 'anexe_categ',
    limit: 100,
    mincount: 1
  },
  publictinta_categ: {
    type: 'terms',
    field: 'publictinta_categ',
    limit: 100,
    mincount: 1
  },
  tiparie_categ: {
    type: 'terms',
    field: 'tiparie_categ',
    limit: 100,
    mincount: 1
  },
  institutie_id: {
    type: 'terms',
    field: 'institutie_id',
    limit: 100,
    mincount: 1
  }
} as const;

export const SOLR_FIELD_MAPPING: Record<string, string> = {
  domainId: 'domeniu_id',
  categoryId: 'categorie_id',
  typeId: 'tip_id',
  countyId: 'judet_id',
  cityId: 'localitate_id',
  annexes: 'anexe_categ',
  targetAudience: 'publictinta_categ',
  areas: 'tiparie_categ',
  availabilityTypeId: 'tipdisponibilitate_id',
  institutionId: 'institutie_id'
};

export const SOLR_DEFAULT_PARAMS: Record<string, string> = {
  wt: 'json',
  indent: 'true',
  'q.op': 'OR',
  mm: '2<75%',
  defType: 'edismax',
  qf: 'nume^6 descriere^3 categorie_nume^2 domeniu_nume^2 judet_nume^2 localitate_nume^2 tip_nume^1 tipdisponibilitate_nume^1 anexe_categ^1 publictinta_categ^1 tiparie_categ^1 institutie_nume^2',
  pf: 'nume^10 descriere^5',
  tie: '0.1',
  df: 'nume',
  'q.alt': '*:*'
};
